import React from "react";

interface IProps {
  searchString: string;
  setSearchString: (q:string) => void
}
declare const translations: {[key:string] : string};

const Search: React.FC<IProps> = ({ searchString, setSearchString }) => {

  return (
    <>
      <div className="search">
        <input type="text"
          value={searchString}
          placeholder={translations.search}
          onChange={(e) => { setSearchString(e.currentTarget.value) }}
        />
        <i className="icon-search"></i>
      </div>
    </>
  );
}

export default Search;